<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosPagamento from './compartilhado/FormDadosPagamento.vue';
  import DadosBancarios from './compartilhado/FormDadosBancarios.vue';
  import solicitacaoPagamentoServico from '../../servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import Radio from '~componentes/Radio.vue';
  import { checkbox } from 'vue-strap';
  
  export default {
    components: { DadosCadastrais, DadosPagamento, DadosBancarios, AdicionarArquivos, ListaDeArquivos, checkbox, Radio },
    data() {
      return {
        documento: '',
        mostrarFormulario: false,
        solicitacao: this.camposSolicitacao(),
        carregando: false,
        dadosBancarios: [],
        dadosBancariosPIX: [],
        configuracao: this.$storage.configuracao(),
        arquivos: [],
        desabilitarBeneficiario: false,
        usuario: this.$storage.usuario(),
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Pagamento de Pessoa Jurídica - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-pagamento-pj.nova';
    },
    methods: {
      buscaDesabilitarBeneficiario() {
        if (this.configuracao.permissaoAlteracaoNomeBeneficiario != 0)
          return false;

        if (!this.solicitacao.documentoTerceiro)
          return false;

        return pessoaServico
          .busca(this.solicitacao.documentoTerceiro)
          .then(pessoa => {
            if (pessoa.nomePessoaFisicaJuridica)
              this.desabilitarBeneficiario = true;
          })
          .catch(error => {
            });
      },
      buscarBeneficiario() {
        $('#avancar').button('loading');
        
        return pessoaServico
          .busca(this.documento)
          .then(pessoa => {
            $('#avancar').button('reset');
            
            this.solicitacao.documentoTerceiro = pessoa.cpfCnpj; 
            this.buscaDesabilitarBeneficiario();
            this.dadosBancarios = pessoa.dadosBancarios;
            this.dadosBancariosPIX = pessoa.dadosBancariosPIX;
            this.solicitacao.nomeTerceiro = pessoa.nomePessoaFisicaJuridica.substring(0, 100);
            this.solicitacao.endereco = pessoa.endereco.substring(0, 60);
            this.solicitacao.numero = pessoa.numero.substring(0, 10);
            this.solicitacao.complemento = pessoa.complemento.substring(0, 80);
            this.solicitacao.bairro = pessoa.bairro.substring(0, 60);
            this.solicitacao.cidade = pessoa.cidade.substring(0, 60);
            this.solicitacao.uf = pessoa.estado.substring(0, 2);
            this.solicitacao.cep = pessoa.cep;
            this.solicitacao.pisPasep = pessoa.pisPasep;
            this.solicitacao.telefoneResidencial = pessoa.telefone1;
            this.solicitacao.telefoneComercial = pessoa.telefone2;
            this.solicitacao.fax = pessoa.fax;
            this.solicitacao.emailTerceiro = pessoa.email.substring(0, 300);
            this.solicitacao.inss = pessoa.inss;
            this.solicitacao.identidade = pessoa.identidadeInscEstadual.substring(0, 20);
            this.solicitacao.inscricaoMunicipal = pessoa.identidadeInscMunicipal.substring(0, 20);
            if (pessoa.dataNascimento) {
              this.solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(pessoa.dataNascimento);
            }
            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.$events.emit('carregarProjetos');
          })
          .catch(error => {
            $('#avancar').button('reset');

            this.solicitacao.documentoTerceiro = this.documento;
            
			      this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.$events.emit('carregarProjetos');
          });
      },
      validarBeneficiario() {
        this.$validator
          .validate('documento', this.documento)
          .then(valido => {
            if (!valido) throw new Error("validacao");
          })
          .then(this.buscarBeneficiario)
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      validarCompraDireta(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (!this.solicitacao.compraDireta)
          return true;

        var valorLimiteCompraDireta = 0;
        var valorSolicitacao = 0;

        if (this.solicitacao.rateio.projeto.valorLimiteCompraDireta)
          valorLimiteCompraDireta = this.$options.filters.formatarNumero(this.solicitacao.rateio.projeto.valorLimiteCompraDireta, true);

        if (this.solicitacao.rateio.valorRateio)
          valorSolicitacao = this.$options.filters.formatarNumero(this.solicitacao.rateio.valorRateio, true);

        if ((valorSolicitacao - valorLimiteCompraDireta) <= 0) return true;

        this.$swal(
          '',
          'O valor da solicitação de compra direta está limitado a um valor de até ' + `R$ ${this.$options.filters.formatarNumero(valorLimiteCompraDireta)}`,
          'info'
        );

        $('#tabs a[href="#tab-dados-pagamento"]').tab('show');
        throw new Error("validacao");
      },
      mostrarInstrucoes() {
        if (!this.configuracao.instrucoesSolPagamentoPJ || this.$route.params.id) return;

        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.instrucoesSolPagamentoPJ.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      mostrarInstrucoesCompraDireta() {
        return;

        if (!this.configuracao.observacaoCompraDiretaPagamento)
          return;

        if (!this.usuario.permissoes.solCompraDireta)
          return;

        if (!this.solicitacao.rateio.projeto.permiteUtilizarCompraDireta)
          return;

        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.observacaoCompraDiretaPagamento.replace(/\r\n/g, '<br>'),
          type: 'success',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      salvar() {
        $('#salvar').button('loading');
        
        this.$refs.dadosCadastrais
          .validar()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosPagamento.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-pagamento"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosBancarios.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-bancarios"]').tab('show');
            }

            return valido;
          })
          .then(this.validarAnexosNF)
          .then(this.validarAnexosBoleto)
          .then(this.validarArquivosObrigatorio)
          .then(this.validarCompraDireta)
          .then(valido => {
            this.mostrarInstrucoesCompraDireta()

            return valido;
          })
          .then(this.enviar)
          .then(id => {
            this.$imprimirRelatorio('solicitacao-pagamento-pj.relatorio', id, 'solicitacao-pagamento-pj');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
          });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

        copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
        
        if (this.$route.params.id) {
          return solicitacaoPagamentoServico.alterar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos, this.$route.params.idCript);
        } else {
          return solicitacaoPagamentoServico.adicionar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos);
        }
      },
      camposSolicitacao() {
        return {
          idCoordenador: null,
          dataSolicitacao: null,
          dataPagamento: '',
          documentoTerceiro: null,
          nomeTerceiro: null,
          observacao: '',
          solicitacaoEfetivada: null,
          formaPagamento: '',
          agencia: null,
          banco: null,
          contaCorrente: null,
          valor: '',
          pertenceQuadro: false,
          tipoQuadro: '',
          matricula: null,
          outroQuadro: null,
          dataNascimento: '',
          identidade: null,
          inss: null,
          pisPasep: null,
          cmc: null,
          numCmc: null,
          endereco: null,
          numero: null,
          complemento: null,
          bairro: null,
          cidade: null,
          cep: null,
          uf: '',
          telefoneResidencial: null,
          telefoneComercial: null,
          fax: null,
          tipoPagamento: '',
          statusSolicitacao: null,
          dataLiberacao: null,
          observacaoLiberacao: null,
          liberacaoCoordenador: null,
          dadosVerificados: null,
          totalReenvio: null,
          siafi: null,
          tipoConta: '',
          tipoPix: '',
          chavePix: '',
          idUsuario: null,
          pagamentoDiaria: null,
          liberacaoCoordenador2: null,
          idRubrica: '',
          idSubrubrica: '',
          idConta: '',
          idProtocolo: null,
          tipoSolicitacao: 2,
          emailTerceiro: null,
          idSetorSolicitacao: null,
          idResponsavelSolicitacao: null,
          idUsuarioResponsavel: null,
          justicicativa: null,
          descricao: null,
          idDetalheRateio: null,
          idCategoriaFinanceira: null,
          inssOutraFonte: false,
          inssOutraFonteValor: '',
          idContaPagar: null,
          notaFiscal: null,
          dataEmissao: '',
          dataVencimento: '',
          idContrato: null,
          inscricaoMunicipal: null,
          nomeSolicitante: null,
          emailSolicitante: null,
          telefoneSolicitante: null,
          compraDireta: null,
          tipoDocumento: null,
          solicitacaoPJAnexouNF: null,
          solicitacaoPJJustificouNF: null,
          solicitacaoPJAnexouBoleto: null,
          solicitacaoPJJustificouBoleto: null,
          solicitacaoPJJustificativaNF: null,
          rateio: {
            idProjeto: '',
            valorRateio: '',
            idDetalheRateio: '',
            idProjetoMetaEtapa: '',
            projeto: {
              idProjeto: '',
              nomeProjeto: '',
              utilizarMetaEtapaProjeto: false,
              valorLimiteCompraDireta: 0.0,
              permiteUtilizarCompraDireta: false,
            }
          }
        };
      },
      limparDadoBancario() {
        if (this.solicitacao.formaPagamento !== 0) {
          this.solicitacao.banco = '';
          this.solicitacao.agencia = '';
          this.solicitacao.contaCorrente = '';
          this.solicitacao.tipoPix = '';
          this.solicitacao.chavePix = '';
          this.solicitacao.tipoConta = '';

          this.$validator.reset();
        }
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;
        let idProjeto = null;

        solicitacaoPagamentoServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
            idProjeto = solicitacao.rateio.idProjeto;
          })
          .then(() => this.$refs.dadosCadastrais.listaContas(idProjeto))
          .then(() => {
            if (solicitacao.rateio.projeto.utilizarMetaEtapaProjeto) {
              this.$refs.dadosCadastrais.listaDeMetaEtapas(idProjeto)
            }
          })
          .then(() => {
            if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb || solicitacao.rateio.projeto.utilizarRubricaSubrubricaWeb) {
              return this.$refs.dadosCadastrais.listaDeRubricas(idProjeto);
            }
          })
          .then(() => {
            if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb || solicitacao.rateio.projeto.utilizarRubricaSubrubricaWeb) {
              return this.$refs.dadosCadastrais.listaDeSubrubricas(idProjeto, solicitacao.idRubrica);
            }
          })
          .then(() => {
            return this.carregarDadosBancarios(solicitacao.documentoTerceiro);
          })
          .then(() => {
            return this.carregarDadosBancariosPIX(solicitacao.documentoTerceiro);
          })
          .then(() => {
            solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(solicitacao.dataNascimento);
            solicitacao.dataEmissao = this.$options.filters.formatarNumeroEmData(solicitacao.dataEmissao);
            solicitacao.dataVencimento = this.$options.filters.formatarNumeroEmData(solicitacao.dataVencimento);
            solicitacao.dataPagamento = this.$options.filters.formatarNumeroEmData(solicitacao.dataPagamento);
          })
          .then(() => solicitacaoPagamentoServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'solicitacao', solicitacao);
            this.buscaDesabilitarBeneficiario();

            if (solicitacao.tipoConta != null)
              this.$refs.dadosBancarios.setarTipoBancario(parseInt(solicitacao.tipoConta));

            this.carregando = false;
          });
      },
      carregarDadosBancarios(cpf) {
        return pessoaServico
          .dadosBancarios(cpf)
          .then(dadosBancarios => {
            this.dadosBancarios = dadosBancarios;
          })
      },
      carregarDadosBancariosPIX(cpf) {
        return pessoaServico
          .dadosBancariosPIX(cpf)
          .then(dadosBancarios => {
            this.dadosBancariosPIX = dadosBancarios;
          })
      },
      limparInssOutraFonte() {
        if (!this.solicitacao.inssOutraFonte) {
          this.solicitacao.inssOutraFonteValor = null;
        }
      },
      limparPertenceQuadro() {
        if (!this.solicitacao.pertenceQuadro) {
          this.solicitacao.tipoQuadro = '';
        }
      },
      download(arquivo) {
        solicitacaoPagamentoServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
      async validarArquivosObrigatorio() {
        if (!this.configuracao.usarArquivosSolicitacaoPagamentos)
          return true;

        if ((this.configuracao.solicitacaoPJAnexarNF == false) && (this.configuracao.solicitacaoPJAnexarBoleto == false))
          return true;

        var quantidadeArquivo = 0;
        var quantidadeMinimaArquivos = 0;

        if (this.solicitacao.solicitacaoPJAnexouNF == 'true')
          quantidadeMinimaArquivos += 1;

        if (this.solicitacao.solicitacaoPJAnexouBoleto == 'true')
          quantidadeMinimaArquivos += 1;

        for (var i = 0; i < this.$refs.adicionarArquivos.arquivos.length; i++) {
          if (this.$refs.adicionarArquivos.arquivos[i]) {
            quantidadeArquivo += 1;
          }
        }

        if (this.$refs.listaArquivos) {
          for (var i = 0; i < this.$refs.listaArquivos.arquivos.length; i++) {
            if (this.$refs.listaArquivos.arquivos[i]) {
              quantidadeArquivo += 1;
            }
          }
        }

        if (quantidadeArquivo < quantidadeMinimaArquivos) {
          $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show');

          this.$swal(
            '',
            'É necessário anexar pelo menos ' + (quantidadeMinimaArquivos - quantidadeArquivo) + ' arquivo(s) ',
            'info'
          );

          $('#salvar').button('reset');
          throw new Error('validacao');
        }

        return true;
      },
      validarAnexosNF(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (!this.configuracao.solicitacaoPJAnexarNF)
          return true;

        let msgErro = "";
        let validou = true;

        if (!((this.solicitacao.solicitacaoPJAnexouNF == 'true') || (this.solicitacao.solicitacaoPJAnexouNF == 'false'))) {
          validou = false;
        }

        if (this.solicitacao.solicitacaoPJAnexouNF == 'false' && !this.solicitacao.solicitacaoPJJustificouNF) {
          validou = false;
        }
      
        if (!validou) msgErro = `É necessário informar se anexou a Nota Fiscal e, em caso negativo, selecionar que está ciente de que não anexou o documento.`

        if (msgErro) {
          $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show');

          this.$swal(
            '',
            msgErro,
            'info'
          );
          
          throw new Error("validacao");
          return false;
        }
        else return this.$validator.validateAll();
      },
      validarAnexosBoleto(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (!this.configuracao.solicitacaoPJAnexarBoleto)
            return true;

        if (this.solicitacao.formaPagamento !== 3)
            return true;

        let msgErro = "";
        let validou = true;

        if (!((this.solicitacao.solicitacaoPJAnexouBoleto == 'true') || (this.solicitacao.solicitacaoPJAnexouBoleto == 'false'))) {
          validou = false;
        }

 
        /*if (this.solicitacao.solicitacaoPJAnexouBoleto == 'false' && !this.solicitacao.solicitacaoPJJustificouBoleto) {
          validou = false;
        }*/

        if (!validou) msgErro = `É necessário informar se anexou o Boleto.`

        if (msgErro) {
          $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show');

          this.$swal(
            '',
            msgErro,
            'info'
          );

          throw new Error("validacao");
          return false;
        }
        else return valido;
      },
    },
    created() {
      if (this.$route.params.id) {
        this.$set(this, 'mostrarFormulario', true);
        this.carregar(this.$route.params.id);
      }
    },
    watch: {
      'solicitacao.formaPagamento': 'limparDadoBancario',
      'solicitacao.inssOutraFonte': 'limparInssOutraFonte',
      'solicitacao.pertenceQuadro': 'limparPertenceQuadro',
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form @submit.prevent="validarBeneficiario">

      <div class="row" v-if="mostrarFormulario">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">

            <ul class="nav nav-tabs">
              <li class="active">
                <a
                  data-toggle="tab"
                  href="#tab-dados-cadastrais">
                  Dados cadastrais
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#tab-dados-pagamento">
                  Dados para o pagamento
                </a>
              </li>
              <li :class="{'disabled': solicitacao.formaPagamento !== 0}">
                <a
                  @click.prevent=""
                  :data-toggle="solicitacao.formaPagamento === 0 ? 'tab' : ''"
                  href="#tab-dados-bancarios">
                  Dados bancários
                </a>
              </li>
              <li v-if="configuracao.usarArquivosSolicitacaoPagamentos">
                <a
                  data-toggle="tab"
                  href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>
              <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoPagamentos">
                <a
                  data-toggle="tab"
                  href="#tab-lista-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-dados-cadastrais" class="tab-pane active">
                <div class="panel-body">
                  <dados-cadastrais
                    ref="dadosCadastrais"
                    :solicitacao="solicitacao"
                    :desabilitarBeneficiario="this.desabilitarBeneficiario"
                    :carregando="carregando"
                    :edicao="!!$route.params.id">
                  </dados-cadastrais>
                </div>
              </div>
              
              <div id="tab-dados-pagamento" class="tab-pane">
                <div class="panel-body">
                  <dados-pagamento
                    ref="dadosPagamento"
                    :solicitacao="solicitacao"
                    :edicao="!!$route.params.id">
                  </dados-pagamento>
                </div>
              </div>
              
              <div id="tab-dados-bancarios" class="tab-pane">
                <div class="panel-body">
                  <dados-bancarios ref="dadosBancarios"
                                   :solicitacao="solicitacao"
                                   :edicao="!!$route.params.id"
                                   :dadosBancarios="dadosBancarios"
                                   :dadosBancariosPIX="dadosBancariosPIX">
                  </dados-bancarios>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane">
                  <div class="panel-body">
                      <adicionar-arquivos ref="adicionarArquivos">
                      </adicionar-arquivos>

                      <div class="hr-line-dashed" v-if="configuracao.solicitacaoPJAnexarNF || configuracao.solicitacaoPJAnexarBoleto"></div>

                      <h3 class="m-t-none m-b margin-top-5" v-if="configuracao.solicitacaoPJAnexarNF || configuracao.solicitacaoPJAnexarBoleto">Arquivos anexados:</h3>

                      <div class="hr-line-dashed" v-if="configuracao.solicitacaoPJAnexarNF || configuracao.solicitacaoPJAnexarBoleto"></div>

                      <div class="row" v-if="configuracao.solicitacaoPJAnexarNF">
                          <div class="col-sm-12">
                              <div class="form-group required">
                                  <label class="control-label" for="anexouNF" style="padding-top: 11px;">Anexou a nota fiscal?</label>
                              </div>
                          </div>
                      </div>

                      <div class="row" v-if="configuracao.solicitacaoPJAnexarNF">
                        <div class="col-sm-2">
                          <div class="form-group required">
                            <radio v-model="solicitacao.solicitacaoPJAnexouNF"
                                   selected-value="true"
                                   type="success"
                                   :inline="true"
                                   class="margin-right-10"
                                   @change="solicitacao.solicitacaoPJJustificouNF = null"
                                   :class="[true ? '' : 'radioLeft']">
                              Sim
                            </radio>
                            <radio v-model="solicitacao.solicitacaoPJAnexouNF"
                                   selected-value="false"
                                   data-vv-name="anexouNF"
                                   type="success"
                                   :inline="true">
                              Não
                            </radio>
                          </div>
                        </div>

                        <div class="col-sm-3" v-if="solicitacao.solicitacaoPJAnexouNF == 'false'" style="margin-left: -90px;">
                          <checkbox v-model="solicitacao.solicitacaoPJJustificouNF" :true-value="true" type="success" required>
                            <small>Me comprometo a inserir a nota fiscal no Sistema Manager após o recebimento do produto.</small>
                          </checkbox>
                        </div>

                        <div class="col-sm-7" v-if="solicitacao.solicitacaoPJAnexouNF == 'false'">
                          <div class="form-group required" :class="{'has-error': errors.has('justificativa')}">
                            <label class="control-label" for="justificativa">Justificar o motivo de não ter inserido a nota fiscal</label>

                            <input type="text"
                                   class="form-control"
                                   id="justificativa"
                                   v-model="solicitacao.solicitacaoPJJustificativaNF"
                                   data-vv-name="justificativa"
                                   data-vv-as="Justificativa"
                                   v-validate="'required'">

                            <p class="text-danger" v-show="errors.has('justificativa')">{{ errors.first('justificativa') }}</p>
                          </div>
                        </div>
                      </div>

                      <div class="row" v-if="configuracao.solicitacaoPJAnexarBoleto && solicitacao.formaPagamento === 3">
                          <div class="col-sm-12">
                              <div class="form-group required">
                                  <label class="control-label" for="anexouBoleto" style="padding-top: 11px;">Anexou o boleto dentro do vencimento?</label>
                              </div>
                          </div>
                      </div>

                      <div class="row" v-if="configuracao.solicitacaoPJAnexarBoleto && solicitacao.formaPagamento === 3">
                          <div class="col-sm-2">
                              <div class="form-group" :class="{'required': true }">
                                  <radio v-model="solicitacao.solicitacaoPJAnexouBoleto"
                                         selected-value="true"
                                         type="success"
                                         :inline="true"
                                         class="margin-right-10"
                                         @change="solicitacao.solicitacaoPJJustificouBoleto = null"
                                         :class="[true ? '' : 'radioLeft']">
                                      Sim
                                  </radio>
                                  <radio v-model="solicitacao.solicitacaoPJAnexouBoleto"
                                         selected-value="false"
                                         data-vv-name="anexouBoleto"
                                         type="success"
                                         :inline="true">
                                      Não
                                  </radio>
                              </div>
                          </div>

                          <div class="col-sm-10" v-if="false" style="margin-left: -90px;">
                              <checkbox v-model="solicitacao.solicitacaoPJJustificouBoleto" :true-value="true" type="success" required>
                                  <small>Texto que compromete enviar Boleto</small>
                              </checkbox>
                          </div>
                      </div>
                  </div>
              </div>

              <div id="tab-lista-arquivos" class="tab-pane">
                <div class="panel-body">
                  <lista-de-arquivos
                    :arquivos="arquivos"
                    @download="download"
                    ref="listaArquivos">
                  </lista-de-arquivos>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
      
      <div class="row" v-if="!mostrarFormulario">
        <div class="col-sm-12">
          <div class="form-group required" :class="{'has-error': errors.has('documento')}">
            <label class="control-label" for="documento">CNPJ da Empresa Beneficiária</label>

            <input type="text"
                   class="form-control"
                   id="documento"
                   v-model="documento"
                   data-vv-as="documento"
                   data-vv-name="documento"
                   v-mascara="'cnpj'"
                   v-validate="'required|cnpj'">

            <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link 
                class="btn btn-default" 
                :to="{ name: 'solicitacao-pagamento-pj' }" 
                v-show="!mostrarFormulario || !!$route.params.id" 
                active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button
                id="avancar"
                type="button" 
                class="btn btn-primary" 
                @click="validarBeneficiario" 
                v-show="!mostrarFormulario"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
              Avançar 
              <i class="fa fa-arrow-right"></i>
            </button>
            
            <button 
                type="button" 
                class="btn btn-default" 
                @click="mostrarFormulario = false, resetarComponente()" 
                v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta 
            </button>

            <button 
                id="salvar"
                type="button" 
                class="btn btn-primary" 
                @click="salvar" 
                v-show="mostrarFormulario"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar 
            </button>
          </div>
        </div>
      </div>
      
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-pagamento/juridica/componentes/SolicitacaoPagamentoPjForm.vue